/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumTipoDestinatarioDTOCodice =
  (typeof EnumTipoDestinatarioDTOCodice)[keyof typeof EnumTipoDestinatarioDTOCodice];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumTipoDestinatarioDTOCodice = {
  RICHIEDENTE: 'RICHIEDENTE',
  TITOLARE: 'TITOLARE',
  CO_TITOLARI: 'CO_TITOLARI',
  RESPONSABILE_PROCEDIMENTO: 'RESPONSABILE_PROCEDIMENTO',
  ENDOPROCEDIMENTI_PRIMO_LIVELLO: 'ENDOPROCEDIMENTI_PRIMO_LIVELLO',
  PROCURATORE: 'PROCURATORE',
  GESTORE: 'GESTORE',
  DELEGATI_FIRMA: 'DELEGATI_FIRMA',
  DELEGATI_COMPILAZIONE: 'DELEGATI_COMPILAZIONE',
  ALTRO_UFFICIO_VARIABILE: 'ALTRO_UFFICIO_VARIABILE',
} as const;
